require('/Users/ratana/Documents/dev-web/lowcode/lowcode-engine/node_modules/@alifd/overlay/es/style.js');
import InternalOverlay from './overlay';
import Popup from './popup';
import OverlayContext from './overlay-context';
var Overlay = InternalOverlay;
Overlay.Popup = Popup;
Overlay.OverlayContext = OverlayContext;
export default Overlay;